import {FunctionComponent, ReactNode} from 'react'

type ProductInfoProps = {
    product?: any
}

const ProductInfo: FunctionComponent<ProductInfoProps> = ({product}) => {

    const Label = ({title, value, enable, className, green}: { title: string | ReactNode; value: string | ReactNode; enable: boolean; className?: string | null; green?: boolean }) => {
        const enableBg = green ? "bg-green-100 group-hover:bg-green-200" : "bg-gray-100 group-hover:bg-gray-200"
        const enableText = green ? "text-green-800 group-hover:text-green-900" : "text-gray-900 group-hover:text-gray-900"
        return (
            <div className={`py-sm px-md h-[50px] rounded-md transition-all ${enable ? enableBg : "bg-gray-50 group-hover:bg-gray-100"} ${enable ? enableText : "text-gray-400 group-hover:text-gray-900"} ${className || ""}`}>
                <p className={`${green && enable ? "text-green-600" : "text-gray-400"} text-xs`}>{title}</p>
                <p className={` text-sm  capitalize `}>{value}</p>
            </div>
        )
    }
    return (
        <>
            <Label
                title="Status"
                value={product.commerce_status}
                enable={product.commerce_status === "active"}
                className={`w-[100px] ${product.commerce_status === "removed" ? "text-red-600" : ""}`}
            />
            <Label
                title="SKU"
                value={product.sku}
                enable={product.is_enable_customization}
                className={"w-[130px]"}
            />

            <Label
                title="Customization"
                value={product.product_profile_id ? "Enabled" : "Disabled"}
                enable={!!product.product_profile_id}
                green={!!product.product_profile_id}
                className={"w-[120px]"}
            />


            {product.bundle_quantity > 0 && product.is_bundle && (
                <Label
                    title="Quantity"
                    value={`${product.bundle_quantity}`}
                    enable={true}

                />
            )}
            {product.is_bundle && (
                <Label
                    title="Bundle"
                    value={`${product.bundle?.items?.length || "0"} item${product.bundle?.items?.length > 1 ? "s" : ""}`}
                    enable={product.is_bundle}

                />
            )}







        </>
    )
}

export default ProductInfo
